import { UpdateFormPostprocessorComponent } from './update-form-postprocessor/update-form-postprocessor.component'
import { CreateFormPostprocessorComponent } from './create-form-postprocessor/create-form-postprocessor.component'
import { FormPostprocessorsComponent } from './form-postprocessors.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const formPostprocessorsRoutes: Routes = [
  {
    path: 'admin/form-postprocessors',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'POSTPROCESSOR_SETTINGS',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: FormPostprocessorsComponent,
        data: {
          permissions: {
            only: 'POSTPROCESSOR_SETTINGS',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateFormPostprocessorComponent,
        data: {
          permissions: {
            only: 'POSTPROCESSOR_SETTINGS',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateFormPostprocessorComponent,
        data: {
          permissions: {
            only: 'POSTPROCESSOR_SETTINGS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
